module.exports = __webpack_public_path__ + "img/notified_img.0e2f2b84.svg";